<nb-card>
  <nb-card-header>
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <i class="fal fa-user ms-2"></i>
        <span>اطلاعات کاربری</span>
      </div>
      <div class="d-flex align-items-center">
        <button
          [nbSpinner]="getTokenLoading"
          nbSpinnerSize="small"
          [disabled]="getTokenLoading"
          *ngIf="checkScope('AND', 'admin:view:user:token')"
          (click)="getUserToken()"
          class="ms-2"
          size="small"
          nbButton
          hero
          outline
          status="primary"
        >
          ورود به اکانت کاربر
        </button>
        <button (click)="openNotesModal()" nbButton size="small" hero outline status="success">
          یادداشت‌ها
        </button>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <nb-tabset (changeTab)="tabChanged($event)">
      <nb-tab *ngIf="checkScope('AND', 'admin:edit:user')" tabTitle="اطلاعات شناسایی">
        <div class="row mt-3">
          <div class="col-12">
            <div class="row mb-3 align-items-center">
              <div class="col-auto d-flex ms-3 align-items-center">
                <label class="col-auto ms-2 position-relative" style="bottom: 4px">
                  کاربر فعال
                </label>
                <div class="col-12 col-lg-9">
                  <nb-toggle [(checked)]="user.active"></nb-toggle>
                </div>
              </div>
              <div class="col-auto d-flex align-items-center">
                <label class="col-auto ms-2 position-relative" style="bottom: 4px">
                  ورود دو عاملی
                </label>
                <div class="col-12 col-lg-9">
                  <nb-toggle [(checked)]="user.googleAuthEnabled"></nb-toggle>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">نام</label>
              <div class="col-12 col-lg-9">
                <nb-form-field>
                  <input
                    nbInput
                    fullWidth
                    type="text"
                    [status]="error['firstName'] === undefined ? 'basic' : 'danger'"
                    [(ngModel)]="user.firstName"
                  />
                  <app-validation-error [errors]="error" name="firstName"></app-validation-error>
                </nb-form-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">نام خانوادگی</label>
              <div class="col-12 col-lg-9">
                <nb-form-field>
                  <input
                    nbInput
                    fullWidth
                    type="text"
                    [status]="error['lastName'] === undefined ? 'basic' : 'danger'"
                    [(ngModel)]="user.lastName"
                  />
                  <app-validation-error [errors]="error" name="lastName"></app-validation-error>
                </nb-form-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">شماره همراه</label>
              <div class="col-12 col-lg-9">
                <nb-form-field>
                  <input
                    nbInput
                    fullWidth
                    type="number"
                    [status]="error['phone'] === undefined ? 'basic' : 'danger'"
                    [(ngModel)]="user.phone"
                  />
                  <app-validation-error [errors]="error" name="phone"></app-validation-error>
                </nb-form-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">شماره تلفن ثابت</label>
              <div class="col-12 col-lg-9">
                <nb-form-field>
                  <input
                    nbInput
                    fullWidth
                    disabled
                    type="number"
                    [status]="error['landlinePhone'] === undefined ? 'basic' : 'danger'"
                    [(ngModel)]="user.landlinePhone"
                  />
                  <app-validation-error
                    [errors]="error"
                    name="landlinePhone"
                  ></app-validation-error>
                </nb-form-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">ایمیل</label>
              <div class="col-12 col-lg-9">
                <nb-form-field>
                  <input
                    nbInput
                    fullWidth
                    [status]="error['email'] === undefined ? 'basic' : 'danger'"
                    [(ngModel)]="user.email"
                  />
                  <app-validation-error [errors]="error" name="email"></app-validation-error>
                </nb-form-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">جنسیت</label>
              <div class="col-12 col-lg-9">
                <nb-select
                  placeholder="جنسیت"
                  fullWidth
                  id="gender"
                  [status]="error['gender'] === undefined ? 'basic' : 'danger'"
                  [(selected)]="user.gender"
                >
                  <nb-option [value]="'male'">مرد</nb-option>
                  <nb-option [value]="'female'">زن</nb-option>
                </nb-select>
                <app-validation-error [errors]="error" name="gender"></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">کد اتباع</label>
              <div class="col-12 col-lg-9">
                <nb-form-field>
                  <input
                    nbInput
                    fullWidth
                    type="text"
                    appOnlyNumber
                    [status]="error['foreignerId'] === undefined ? 'basic' : 'danger'"
                    [(ngModel)]="user.foreignerId"
                  />
                  <app-validation-error [errors]="error" name="foreignerId"></app-validation-error>
                </nb-form-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">کد ملی</label>
              <div class="col-12 col-lg-9">
                <nb-form-field>
                  <input
                    nbInput
                    fullWidth
                    type="text"
                    appOnlyNumber
                    [status]="error['nationalId'] === undefined ? 'basic' : 'danger'"
                    [(ngModel)]="user.nationalId"
                  />
                  <app-validation-error [errors]="error" name="nationalId"></app-validation-error>
                </nb-form-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">تاریخ تولد</label>
              <div class="col-12 col-lg-9">
                <app-datepicker
                  (dateSelected)="setBirthday($event)"
                  [setYear]="birthday.year || 0"
                  [setMonth]="birthday.month || 0"
                  [setDay]="birthday.day || 0"
                  [minYear]="1301"
                ></app-datepicker>
                <app-validation-error [errors]="error" name="birthday"></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">کد پستی</label>
              <div class="col-12 col-lg-9">
                <nb-form-field>
                  <input
                    nbInput
                    disabled
                    fullWidth
                    type="number"
                    [status]="error['postalCode'] === undefined ? 'basic' : 'danger'"
                    [(ngModel)]="user.postalCode"
                  />
                  <app-validation-error [errors]="error" name="postalCode"></app-validation-error>
                </nb-form-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">استان</label>
              <div class="col-12 col-lg-9">
                <nb-select
                  [nbSpinner]="provinceLoading"
                  placeholder="استان"
                  disabled
                  (selectedChange)="getProvinceCities($event)"
                  [(selected)]="user.provinceId"
                  [status]="error['provinceId'] === undefined ? 'basic' : 'danger'"
                  fullWidth
                >
                  <nb-option *ngFor="let province of provinces" [value]="province.id">
                    {{ province.name }}
                  </nb-option>
                </nb-select>
                <app-validation-error [errors]="error" name="provinceId"></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">شهر</label>
              <div class="col-12 col-lg-9">
                <nb-select
                  [nbSpinner]="cityLoading"
                  placeholder="شهر"
                  disabled
                  [status]="error['cityId'] === undefined ? 'basic' : 'danger'"
                  fullWidth
                  [(ngModel)]="user.cityId"
                  name="city"
                >
                  <nb-option *ngFor="let city of provinceCity" [value]="city.id">
                    {{ city.name }}
                  </nb-option>
                </nb-select>
                <app-validation-error [errors]="error" name="cityId"></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3" for="address">آدرس</label>
              <div class="col-12 col-lg-9">
                <textarea
                  nbInput
                  [status]="error['address'] === undefined ? 'basic' : 'danger'"
                  fullWidth
                  placeholder="آدرس"
                  disabled
                  [(ngModel)]="user.address"
                  name="address"
                  id="address"
                ></textarea>
                <app-validation-error [errors]="error" name="address"></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row mt-4 justify-content-center">
              <div class="col-6 d-flex justify-content-center">
                <button
                  [disabled]="userInfoLoading"
                  [nbSpinner]="userInfoLoading"
                  (click)="updateUserInfo()"
                  class="save-button"
                  nbButton
                  status="success"
                >
                  ویرایش اطلاعات کاربر
                </button>
              </div>
            </div>
          </div>
        </div>
      </nb-tab>
      <nb-tab tabTitle="تغییر رمز عبور" *ngIf="checkScope('AND', 'admin:edit:users:password')">
        <form [formGroup]="changePassword">
          <div class="row">
            <div class="col-12 col-lg-6 col-xxl-4 mb-3">
              <div class="row align-items-center">
                <label class="col-12 col-lg-3">تغییر رمز عبور</label>
                <div class="col">
                  <nb-form-field>
                    <input
                      nbInput
                      type="text"
                      [status]="error['password'] === undefined ? 'basic' : 'danger'"
                      formControlName="password"
                    />
                    <app-validation-error [errors]="error" name="password"></app-validation-error>
                  </nb-form-field>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 col-xxl-4 mb-3">
              <div class="row align-items-center">
                <label class="col-12 col-lg-3">تکرار رمز عبور</label>
                <div class="col">
                  <nb-form-field>
                    <input
                      nbInput
                      type="text"
                      [disabled]="!changePassword.valid && changePassword.controls.rePassword.dirty"
                      [status]="error['password'] === undefined ? 'basic' : 'danger'"
                      formControlName="rePassword"
                    />
                    <app-validation-error [errors]="error" name="password"></app-validation-error>
                  </nb-form-field>
                  <span *ngIf="changePassword.errors" class="text-danger" style="font-size: 0.7rem">
                    رمز عبور با تکرار رمز عبور یکسان نمیباشد
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 mb-3">
              <div class="row mt-4 justify-content-center">
                <div class="col-6 d-flex justify-content-center">
                  <button
                    [disabled]="userInfoLoading || !changePassword.valid"
                    [nbSpinner]="userInfoLoading"
                    (click)="changeUserPassword()"
                    class="save-button"
                    nbButton
                    status="success"
                  >
                    تغییر رمز عبور
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </nb-tab>
      <nb-tab tabTitle="برچسب" *ngIf="checkScope('OR', 'admin:view:user:label')">
        <div class="row">
          <div class="col-lg-6">
            <nb-card>
              <nb-card-header>لیست برچسب‌های کاربر</nb-card-header>
              <nb-card-body>
                <nb-select
                  *ngIf="checkScope('AND', 'admin:create:user:label')"
                  fullWidth
                  style="max-width: 200px"
                  placeholder="انتخاب برچسب جدید"
                  (selectedChange)="addLabel($event)"
                >
                  <nb-option *ngFor="let label of labels | async" [value]="label">
                    {{ label.label }}
                  </nb-option>
                </nb-select>
                <hr *ngIf="checkScope('AND', 'admin:create:user:label')"/>
                <ng-container *ngIf="checkScope('AND', 'admin:view:user:label')">
                  <ng-container *ngIf="userLabels.length > 0; else emptyList">
                    <nb-tag
                      removable
                      (remove)="deleteUserLabel(label)"
                      *ngFor="let label of userLabels"
                      [style.background-color]="label.color"
                      [style.border-color]="label.color"
                      class="text-white ms-2 mb-2"
                      status="basic"
                      [text]="label.label"
                    ></nb-tag>
                  </ng-container>
                  <ng-template #emptyList>
                    <p class="text-center">هنوز برچسبی برای این کاربر ثبت نشده است</p>
                  </ng-template>
                </ng-container>
              </nb-card-body>
            </nb-card>
          </div>
        </div>
      </nb-tab>

      <nb-tab *ngIf="checkScope('AND', 'admin:edit:user')" tabTitle="احراز هویت">
        <div class="row mt-3">
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-4">تأیید ایمیل</label>
              <div class="col-12 col-lg-8">
                <nb-select placeholder="تأیید ایمیل" fullWidth [(selected)]="user.emailVerified">
                  <nb-option [value]="'NOT_STARTED'">شروع نشده</nb-option>
                  <nb-option [value]="'PENDING'">در حال بررسی</nb-option>
                  <nb-option [value]="'ACCEPTED'">تأیید</nb-option>
                  <nb-option [value]="'REJECTED'">عدم تأیید</nb-option>
                </nb-select>
                <app-validation-error [errors]="error" name="emailVerified"></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-4">تأیید تلفن همراه</label>
              <div class="col-12 col-lg-8">
                <nb-select
                  placeholder="تأیید تلفن همراه"
                  fullWidth
                  [(selected)]="user.phoneVerified"
                >
                  <nb-option [value]="'NOT_STARTED'">شروع نشده</nb-option>
                  <nb-option [value]="'PENDING'">در حال بررسی</nb-option>
                  <nb-option [value]="'ACCEPTED'">تأیید</nb-option>
                  <nb-option [value]="'REJECTED'">عدم تأیید</nb-option>
                </nb-select>
                <app-validation-error [errors]="error" name="phoneVerified"></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-4">تأیید اطلاعات بانکی</label>
              <div class="col-12 col-lg-8">
                <nb-select
                  placeholder="تأیید اطلاعات بانکی"
                  fullWidth
                  [(selected)]="user.bankVerified"
                >
                  <nb-option [value]="'NOT_STARTED'">شروع نشده</nb-option>
                  <nb-option [value]="'PENDING'">در حال بررسی</nb-option>
                  <nb-option [value]="'ACCEPTED'">تأیید</nb-option>
                  <nb-option [value]="'REJECTED'">عدم تأیید</nb-option>
                </nb-select>
                <app-validation-error [errors]="error" name="bankVerified"></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-4">تأیید اطلاعات شناسایی</label>
              <div class="col-12 col-lg-8">
                <nb-select
                  placeholder="تأیید اطلاعات شناسایی"
                  fullWidth
                  [(selected)]="user.identityCardVerified"
                >
                  <nb-option [value]="'NOT_STARTED'">شروع نشده</nb-option>
                  <nb-option [value]="'PENDING'">در حال بررسی</nb-option>
                  <nb-option [value]="'ACCEPTED'">تأیید</nb-option>
                  <nb-option [value]="'REJECTED'">عدم تأیید</nb-option>
                </nb-select>
                <app-validation-error
                  [errors]="error"
                  name="identityCardVerified"
                ></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-4">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-4">تأیید عکس سلفی</label>
              <div class="col-12 col-lg-8">
                <nb-select placeholder="تأیید هویت" fullWidth [(selected)]="user.identityVerified">
                  <nb-option [value]="'NOT_STARTED'">شروع نشده</nb-option>
                  <nb-option [value]="'PENDING'">در حال بررسی</nb-option>
                  <nb-option [value]="'ACCEPTED'">تأیید</nb-option>
                  <nb-option [value]="'REJECTED'">عدم تأیید</nb-option>
                </nb-select>
                <app-validation-error
                  [errors]="error"
                  name="identityVerified"
                ></app-validation-error>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row mt-4 justify-content-center">
              <div class="col-6 d-flex justify-content-center">
                <button
                  [disabled]="userVerifiedLoading"
                  [nbSpinner]="userVerifiedLoading"
                  (click)="updateUserVerified()"
                  class="save-button"
                  nbButton
                  status="success"
                >
                  ویرایش اطلاعات احراز هویت
                </button>
              </div>
            </div>
          </div>
        </div>
      </nb-tab>
      <nb-tab
        *ngIf="checkScope('OR', 'admin:edit:users:credit_cards', 'admin:edit:users:ibans')"
        tabTitle="اطلاعات بانکی"
      >
        <div class="row">
          <div class="col-12 col-lg-6">
            <nb-card>
              <nb-card-header>
                <i class="fal fa-credit-card ms-1"></i>
                شماره کارت
              </nb-card-header>
              <nb-card-body>
                <ng-container *ngIf="creditCards.length > 0; else emptyCreditCard">
                  <div *ngFor="let card of creditCards" class="d-flex w-100 mb-3">
                    <nb-form-field class="w-100">
                      <i
                        nbPrefix
                        *ngIf="deleteLoading && selectedCard === card; else deleteCreditIcon"
                        class="fas fa-sync-alt fa-spin"
                      ></i>
                      <ng-template #deleteCreditIcon>
                        <i
                          nbPrefix
                          (click)="deleteCreditCard(card)"
                          class="fas fa-trash-alt cursor-pointer text-danger"
                        ></i>
                      </ng-template>
                      <input
                        type="text"
                        status="basic"
                        class="card-input"
                        disabled
                        fieldSize="giant"
                        fullWidth
                        nbInput
                        [value]="card.part.join('-')"
                      />
                    </nb-form-field>
                    <nb-select
                      [status]="
                        card.verified === 'ACCEPTED'
                          ? 'success'
                          : card.verified === 'REJECTED'
                          ? 'danger'
                          : 'primary'
                      "
                      class="me-2"
                      size="giant"
                      [nbSpinner]="creditCardLoading && selectedCard === card"
                      [disabled]="creditCardLoading && selectedCard === card"
                      (selectedChange)="setCreditCardStatus(card, $event)"
                      [selected]="card.verified"
                    >
                      <nb-option disabled [value]="'PENDING'">منتظر بررسی</nb-option>
                      <nb-option [value]="'ACCEPTED'">تأیید</nb-option>
                      <nb-option [value]="'REJECTED'">عدم تأیید</nb-option>
                    </nb-select>
                  </div>
                </ng-container>
                <ng-template #emptyCreditCard>
                  <div class="d-flex justify-content-center">
                    <h4 class="p-5">شماره کارت از این کاربر ثبت نشده است.</h4>
                  </div>
                </ng-template>
              </nb-card-body>
            </nb-card>
          </div>
          <div class="col-12 col-lg-6">
            <nb-card>
              <nb-card-header>
                <i class="fal fa-credit-card-blank ms-1"></i>
                شماره شبا
              </nb-card-header>
              <nb-card-body>
                <ng-container *ngIf="userIban.length > 0; else emptyIban">
                  <div *ngFor="let iban of userIban" class="iban">
                    <div class="iban-container">
                      <nb-form-field>
                        <span nbSuffix>IR</span>
                        <i
                          nbPrefix
                          *ngIf="deleteLoading && selectedIban == iban; else deleteIbanIcon"
                          class="fas fa-sync-alt fa-spin"
                        ></i>
                        <ng-template #deleteIbanIcon>
                          <i
                            nbPrefix
                            (click)="deleteIban(iban)"
                            class="fas fa-trash-alt cursor-pointer text-danger"
                          ></i>
                        </ng-template>
                        <input
                          appOnlyNumber
                          appNumberLimit
                          [maxDigit]="24"
                          status="basic"
                          disabled
                          [value]="iban?.iban"
                          dir="ltr"
                          type="text"
                          fullWidth
                          nbInput
                          fieldSize="giant"
                        />
                      </nb-form-field>
                      <nb-select
                        [status]="
                          iban.verified === 'ACCEPTED'
                            ? 'success'
                            : iban.verified === 'REJECTED'
                            ? 'danger'
                            : 'primary'
                        "
                        class="size-giant me-2"
                        [nbSpinner]="ibanLoading && selectedIban === iban"
                        [disabled]="ibanLoading && selectedIban === iban"
                        (selectedChange)="setIbanStatus(iban, $event)"
                        [selected]="iban.verified"
                      >
                        <nb-option disabled [value]="'PENDING'">منتظر بررسی</nb-option>
                        <nb-option [value]="'ACCEPTED'">تأیید</nb-option>
                        <nb-option [value]="'REJECTED'">عدم تأیید</nb-option>
                      </nb-select>
                    </div>
                  </div>
                </ng-container>
                <ng-template #emptyIban>
                  <div class="d-flex justify-content-center">
                    <h4 class="p-5">شماره شبا از این کاربر ثبت نشده است.</h4>
                  </div>
                </ng-template>
              </nb-card-body>
            </nb-card>
          </div>
        </div>
      </nb-tab>
      <nb-tab
        *ngIf="checkScope('AND', 'admin:view:files')"
        tabId="userImages"
        tabTitle="عکس‌‌ها یا ویدیو کاربر"
      >
        <div class="row">
          <div *ngIf="user.faceImagePath" class="col-12 col-lg-4">
            <nb-card>
              <nb-card-header>تصویر روی کارت ملی کاربر</nb-card-header>
              <nb-card-body>
                <div class="img-fluid">
                  <img
                    id="identityImageUserPicture"
                    height="300px"
                    class="img-thumbnail cursor-pointer"
                    [src]="user.faceImagePath"
                    appSecureImage
                  />
                </div>
              </nb-card-body>
            </nb-card>
            <nb-card>
              <nb-card-header>تصویر سلفی کاربر</nb-card-header>
              <nb-card-body>
                <div class="img-fluid">
                  <img
                    id="identityImage"
                    height="300px"
                    class="img-thumbnail cursor-pointer"
                    [src]="user.identityImage"
                    appSecureImage
                  />
                </div>
              </nb-card-body>
            </nb-card>
          </div>
          <div *ngIf="user.nationalCardImage" class="col-12 col-lg-4">
            <nb-card>
              <nb-card-header>تصویر کارت ملی</nb-card-header>
              <nb-card-body>
                <div class="img-fluid">
                  <img
                    id="nationalCardImage"
                    height="300px"
                    class="img-thumbnail cursor-pointer"
                    [src]="user.nationalCardImage"
                    appSecureImage
                  />
                </div>
              </nb-card-body>
            </nb-card>
          </div>
          <div *ngIf="user.identityVideo" class="col-12 col-lg-4">
            <nb-card>
              <nb-card-header>ویدیو سلفی کاربر</nb-card-header>
              <nb-card-body>
                <div class="img-fluid">
                  <video
                    controls
                    class="img-thumbnail cursor-pointer"
                    [src]="user.identityVideo"
                    appSecureVideo
                  ></video>
                </div>
              </nb-card-body>
            </nb-card>
          </div>
          <div *ngIf="user.homeBill" class="col-12 col-lg-4">
            <nb-card>
              <nb-card-header>تصویر قبض</nb-card-header>
              <nb-card-body>
                <div class="img-fluid">
                  <img
                    id="homeBill"
                    height="300px"
                    class="img-thumbnail cursor-pointer"
                    [src]="user.homeBill"
                    appSecureImage
                  />
                </div>
              </nb-card-body>
            </nb-card>
          </div>
        </div>
      </nb-tab>
      <nb-tab *ngIf="checkScope('AND', 'admin:view:user:transactions')" tabTitle="تراکنش های کاربر">
        <div class="row">
          <div class="col-12">
            <app-transactions [userId]="userId"></app-transactions>
          </div>
        </div>
      </nb-tab>
      <nb-tab *ngIf="checkScope('AND', 'admin:view:orders:fee')" tabTitle="میزان کارمزد">
        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            <label class="ms-2">کارمزد پیشفرض:</label>
            <nb-toggle [(ngModel)]="isDefault"></nb-toggle>
          </div>
        </div>
        <div class="row">
          <div class="col-auto d-flex align-items-center">
            <label class="ms-2">میزان کارمزد کاربر:</label>
            <nb-form-field>
              <i nbSuffix class="fas fa-percent"></i>
              <input
                nbInput
                status="primary"
                [status]="error['feePercent'] === undefined ? 'basic' : 'danger'"
                [disabled]="isDefault"
                [(ngModel)]="user.feePercent"
              />
            </nb-form-field>
          </div>
          <div class="col-auto">
            <button
              [disabled]="feeLoading"
              [nbSpinner]="feeLoading"
              (click)="submitFee()"
              class="save-button"
              nbButton
              status="success"
            >
              ثبت
            </button>
          </div>
          <app-validation-error name="feePercent" [errors]="error"></app-validation-error>
        </div>
      </nb-tab>
      <nb-tab tabId="fee" *ngIf="checkScope('AND', 'admin:view:orders:fee')" tabTitle="کارمزد ها">
        <div class="row">
          <app-fee *ngIf="tab?.tabId === 'fee'" [userId]="userId"></app-fee>
        </div>
      </nb-tab>
      <nb-tab *ngIf="checkScope('AND', 'admin:view:users:wallets')" tabTitle="کیف پول">
        <div *ngIf="userAsset" class="row">
          <div *ngFor="let wallet of userAsset.wallet" class="col-12 col-md-6 col-xxl-4">
            <nb-card class="custom-card">
              <nb-card-body>
                <div class="coin-info">
                  <section>
                    <img [src]="wallet.currency.iconPath" class="ms-2"/>
                    <p class="coin-name h6">
                      {{ wallet.currency.id === 'IRR' ? 'ریال' : wallet.currency.name }}
                      ({{ wallet.currency.id }})
                    </p>
                  </section>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <p class="h5 mb-0 ms-2">
                    {{ wallet.balance | number : '1.0-' + wallet.currency?.decimalPrecision }}
                  </p>
                  <p class="h6 mb-0">{{ wallet.currency.name }}</p>
                </div>
                <div class="d-flex flex-column align-items-end mt-2">
                  <p class="mb-0 fs-small text-hint en-num">
                    {{
                    (wallet.currency.id === 'IRR'
                      ? wallet.balance / wallet.currency.usdcPrice
                      : wallet.currency.usdcPrice * wallet.balance) || 0 | number : '1.0-2'
                    }}
                    $
                  </p>
                  <p class="mb-0 fs-small text-hint">
                    {{
                    wallet.currency.id === 'IRR'
                      ? (wallet.balance | number : '1.0-0')
                      : (wallet.currency.irrSellPrice * wallet.balance | number : '1.0-0')
                    }}
                    تومان
                  </p>
                </div>
              </nb-card-body>
            </nb-card>
          </div>
        </div>
      </nb-tab>

      <nb-tab *ngIf="checkScope('AND', 'admin:view:users:sessions')" tabTitle="محدودیت‌های برداشت">
        <div class="row">
          <app-select-currency class="col-12 col-lg-7 col-xxl-5"
                               [multiple]="false"
                               [showRial]="true"
                               (currency)="limit.currency_id = $event[0]?.id"
          ></app-select-currency>
          <div class="col-12 col-lg-5 col-xxl-3">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">سقف روزانه</label>
              <div class="col-12 col-lg-9">
                <nb-form-field>
                  <input
                    nbInput
                    fullWidth
                    type="text"
                    [status]="error['dailyLimit'] === undefined ? 'basic' : 'danger'"
                    [(ngModel)]="limit.daily_withdraw_price"
                  />
                  <app-validation-error [errors]="error" name="dailyLimit"></app-validation-error>
                </nb-form-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-5 col-xxl-3">
            <div class="row mb-3 align-items-center">
              <label class="col-12 col-lg-3">سقف ماهانه</label>
              <div class="col-12 col-lg-9">
                <nb-form-field>
                  <input
                    nbInput
                    fullWidth
                    type="text"
                    [status]="error['monthlyLimit'] === undefined ? 'basic' : 'danger'"
                    [(ngModel)]="limit.monthly_withdraw_price"
                  />
                  <app-validation-error [errors]="error" name="monthlyLimit"></app-validation-error>
                </nb-form-field>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <button
              [disabled]="isSettingLimit"
              [nbSpinner]="isSettingLimit"
              (click)="setLimit()"
              class="save-button"
              nbButton
              status="success"
            >
              ثبت
            </button>
          </div>
        </div>
        <p *ngIf="noLimit">{{noLimit}}</p>
        <table class="table table-bordered text-center">
          <thead>
          <tr>
            <th>ردیف</th>
            <th>ارز</th>
            <th>سقف روزانه</th>
            <th>سقف ماهانه</th>
            <th>عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let limit of userWithdrawLimits; let index = index">
            <td class="cursor-pointer" style="width: 24px">{{index + 1}}</td>
            <td class="cursor-pointer" style="width: 60px">{{limit.currency}}</td>
            <td class="cursor-pointer" style="width: 60px">{{limit.daily_withdraw_price}}</td>
            <td class="cursor-pointer" style="width: 60px">{{limit.monthly_withdraw_price}}</td>
            <td class="cursor-pointer" style="width: 60px">
              <button
                [disabled]="limit.loading"
                [nbSpinner]="limit.loading"
                (click)="setLimit(limit)"
                class="save-button"
                nbButton
                status="success"
              >
                حذف
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </nb-tab>

      <nb-tab *ngIf="checkScope('AND', 'admin:view:users:sessions')" tabTitle="نشست‌های کاربر">
        <app-sessions-shared [userId]="user.id"></app-sessions-shared>
      </nb-tab>
    </nb-tabset>
  </nb-card-body>
</nb-card>

